import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const FirmaPersonenDtoServiceConfig = {
  name: "FirmaPersonenDto",
  annotations: []
} as ServiceConfig;